import React, { Component } from "react";
import { translate } from "react-i18next";
import compose from "ramda/src/compose";

import { Modal } from "shared/components";
import IconCalendar from "../../../../assets/svg/calendar_white.svg";
import RescheduleForm from "../RescheduleForm/index";

class RescheduleModal extends Component {
  render() {
    const { t, isOpen, onClose, demand, customer } = this.props;

    return (
      <Modal
        icon={IconCalendar}
        title={t("MSG_0246")}
        isOpen={isOpen}
        onClose={onClose}
        noOverflow={true}
      >
        <RescheduleForm customer={customer} demand={demand}></RescheduleForm>
      </Modal>
    );
  }
}

const enhance = compose(translate());

export default enhance(RescheduleModal);



// WEBPACK FOOTER //
// ./src/scenes/IncidentManager/components/RescheduleModal/index.js